import degrees2Radians from 'editor/src/util/degrees2Radians';

interface Params {
  bbox: { x1: number; y1: number } | undefined;
  sx: number;
  sy: number;
  angleDeg: number;
  mm2px: (n: number) => number;
}

// Converts the SVG path bbox offset (in element-local mm) into a world-canvas-pixel offset
// that respects the element's visual rotation. For angleDeg = 0 the result is mathematically
// identical to (bbox.x1 * sx * mm2px(1), bbox.y1 * sy * mm2px(1)), so non-rotated text keeps
// rendering exactly as before.
function getSvgOverlayOffset({ bbox, sx, sy, angleDeg, mm2px }: Params): { x: number; y: number } {
  if (!bbox) {
    return { x: 0, y: 0 };
  }
  const dxMm = bbox.x1 * sx;
  const dyMm = bbox.y1 * sy;
  const angleRad = degrees2Radians(angleDeg || 0);
  const cos = Math.cos(angleRad);
  const sin = Math.sin(angleRad);
  const onePx = mm2px(1);
  return {
    x: (dxMm * cos - dyMm * sin) * onePx,
    y: (dxMm * sin + dyMm * cos) * onePx,
  };
}

export default getSvgOverlayOffset;
